import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ProductType, CheckoutType, PriceKeyMap, StoresSlugEnum, AssessmentAttributes } from 'src/app/enums/assessment.enum';
import { CartService } from 'src/app/shared/services/cart/cart.service';
import { ClientService } from 'src/app/shared/services/client.service';

@Component({
  selector: 'app-terms-conditions-course-dialog',
  templateUrl: './terms-conditions-course-dialog.component.html',
  styleUrls: ['./terms-conditions-course-dialog.component.scss']
})
export class TermsConditionsCourseDialogComponent implements OnInit{
  isSelected:boolean = false;
  currentClient: string | null = null;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private cartService: CartService,
    private clientService: ClientService,
  ) { }

  ngOnInit(){
    // console.log(this.data);
    // Get current client
    this.currentClient = this.clientService.getCurrentClient();
  }

  proceedToLevelSelection(buyAction: string){
    // For LMS courses, use simple product type without reports
    const prdType = ProductType.NO_REPORT;

    // Get existing cart items using the service function
    let cartItems = this.cartService.getCartDetailsFromLocalStorage();

    // Extract clientDocId from assessment.clients array based on current client
    // const currentClientSlug = this.currentClient;
    // const clientData = this.data.assessment.clients?.find((client: any) => client.slug === currentClientSlug);
    // const clientDocId = clientData?._id || null;
    // console.log(this.data);
    
    // Create new cart item
    const newCartItem = {
      checkoutType: CheckoutType.TEACHER_ASSESSMENT,
      assessment: {
        isSelected: true,
        buyAction: this.data.buyAction,
        assessmentDocId: this.data.assessment._id,
        title: this.data.assessment.title,
        titleAbbr: this.data.assessment.titleAbbr,
        prdType: prdType,
        price: this.data.assessment[PriceKeyMap[prdType as keyof typeof PriceKeyMap]],
        attributes: this.data.assessment.attributes,
        storeDoc: this.data.assessment.storeDoc,
        clientDoc: this.data.assessment.clientDoc,
      }
    };

    if (buyAction === 'buy_now') {
      this.cartService.addToCart(newCartItem);

      if (newCartItem?.assessment?.attributes && newCartItem?.assessment?.attributes.includes(AssessmentAttributes.LEVELS)) {
        this.router.navigate([this.currentClient, 'teacher', 'assessments', this.data?.assessment?._id, 'buy']);
      }else{
        this.router.navigate([this.currentClient, 'teacher', 'assessments', 'checkout'], {
          queryParams: { type: CheckoutType.TEACHER_ASSESSMENT }
        });
      }
    } 
    else {
      // For add to cart, add item and redirect to my-learnings
      this.cartService.addToCart(newCartItem);
      
      // Emit event to parent component to update cart state
      window.dispatchEvent(new CustomEvent('cartUpdated'));
      
      this.router.navigate([this.currentClient,'teacher', 'dashboard'],{
        queryParams: { tab : 'my-learnings' }
      });
      // this.utilService.showSuccessSnackbar({
      //   msg: 'Assessment Added to Cart',
      //   showIcon: true,
      // });

      // this.cartService.incrementCart(1);
    }
}
}
